import React, { useContext, useEffect, useRef, useState } from 'react';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import SearchIcon from '../../../../../Assets/Modals/SearchIcon.svg';
import ProductCard from './ProductCard';
import { closeModal } from '../../../../../Features/storefrontSlice';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';

function SelectProduct() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    const inventoryProducts = useSelector((state) => state.inventoryManagement.products.products);
    const sectionFormType = useSelector((state) => state.storefront.sectionFormType);
    const selectedCarouselBannerSection = useSelector((state) => state.storefront.selectedCarouselBannerSection);

    const {
        setSelectedProducts,
        setSelectedCategory,
        setSelectedCollection,
        setSelectedCustomCollection,

        singleBanner,
        defaultSingleBanner,
        setSingleBanner,

        setCarouselBanner,
        setSingleBannerDesktop,
        singleBannerDesktop,
        setCarouselBannerDesktop
    } = useContext(StorefrontContext);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const [searchType, setSearchType] = useState('products');
    const [searchInputValue, setSearchInputValue] = useState('');
    const [selectedLocalProduct, setSelectedLocalProduct] = useState({});
    const [list, setList] = useState([]);

    const handleChange = (e) => {
        setSearchInputValue(e.target.value);
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(searchType === 'products') {
                const filteredList = inventoryProducts.filter(item => item.product.status !== 'Draft').filter(product => product.product.productName.toLowerCase().includes(searchInputValue.toLowerCase()))
                setList(filteredList);
            }
            else {
                const filteredList = inventoryProducts.filter(item => item.product.status !== 'Draft').filter(
                    product => product.product.Tag.some(tag =>
                        tag.toLowerCase().includes(searchInputValue.toLowerCase())
                    )
                );
                setList(filteredList);
            }
        }
    }

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const handleNextClick = () => {
        if(Object.keys(selectedLocalProduct).length > 0) {
            if(sectionFormType === 'SINGLE_BANNER') {
                setSingleBanner({
                    ...defaultSingleBanner,
                    image: singleBanner.image,
                    product: selectedLocalProduct,
                });
            }
            if(sectionFormType === 'SINGLE_BANNER_DESKTOP') {
                setSingleBannerDesktop({
                    ...defaultSingleBanner,
                    image: singleBannerDesktop.image,
                    product: selectedLocalProduct,
                });
            }
            if(sectionFormType === 'CAROUSEL_BANNER') {
                setCarouselBanner((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, product: selectedLocalProduct, } } 
                            : item
                    )
                );
            }
            if(sectionFormType === 'CAROUSEL_BANNER_DESKTOP') {
                setCarouselBannerDesktop((prevCarouselBanner) =>
                    prevCarouselBanner.map((item) =>
                        item.title === selectedCarouselBannerSection
                            ? { ...item, link: { ...defaultSingleBanner, product: selectedLocalProduct, } } 
                            : item
                    )
                );
            }
            setSelectedCategory({});
            setSelectedCollection({});
            setSelectedCustomCollection({});
            setSelectedProducts([]);
            dispatch(closeModal());
        }
        else {
            showToast('Select products before proceeding', 'warning');
        }
    }

    const toggleSearchType = () => {
        if(searchType === 'tags') {
            setSearchType('products');
        }
        else {
            setSearchType('tags');
        }
    }

    const addProductHandler = (item) => {
        setSelectedLocalProduct(item)
    }

    const removeProductHandler = () => {
        setSelectedLocalProduct({});
    }

    useEffect(() => {
        setList(inventoryProducts.filter(item => item.product.status !== 'Draft'));
    }, [inventoryProducts]);

    useEffect(() => {}, []);

    return (
        <div ref={wrapperRef} className="w-[91%] h-[90%] bg-[#FFFFFF] rounded-xl overflow-hidden p-6 flex flex-col gap-3 relative">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Add Products</h1>

                <button onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="flex flex-col">
                <div className="border border-[#EAEAEA] bg-[#F5F5F5] rounded-lg p-4 flex items-center gap-1 focus-within:border-primaryColor">
                    <div className="w-6 h-6 flex items-center justify-center">
                        <img src={SearchIcon} alt="Search Icon" />
                    </div>

                    <input 
                        name='product' 
                        id='product' 
                        value={searchInputValue} 
                        onChange={handleChange} 
                        onKeyDown={handleKeyDown} 
                        placeholder={`Search by ${searchType}`} 
                        className='w-[calc(100%-24px)] outline-none bg-transparent font-urbanist-regular font-medium text-base placeholder:text-[#666666]' 
                        type="text" 
                    />
                </div>

                <div className="p-[10px]">
                    <button 
                        className='text-[#1055EB] outline-none font-urbanist-regular font-medium text-base underline decoration-1' 
                        onClick={toggleSearchType}
                    >search by {searchType === 'tags' ? 'products': 'tags'}</button>
                </div>
            </div>

            <div className="max-h-[100%] grid grid-cols-5 gap-x-3 gap-y-3 max-[1280px]:grid-cols-4 max-[1152px]:grid-cols-3 overflow-y-scroll no-scrollbar pb-20">
                {list?.map(product => {
                    const isSelected = selectedLocalProduct?.product?.id === product.product.id;

                    return (
                        <ProductCard 
                            key={product.product.id} 
                            product={product} 
                            addProductToList={val => addProductHandler(val)} 
                            removeProductFromList={val => removeProductHandler(val)} 
                            selected={isSelected} 
                        />
                    )
                })}
            </div>

            <div className="bg-[#FFFFFF] absolute w-full right-0 bottom-0 flex items-center justify-between p-6 shadow-[-9px_0px_18px_0px_#00000033]">
                {/* <p className='font-urbanits-regular font-normal text-[14px] leading-[22px] text-[#121212]'>Note: In the next step, you'll see all available variants for your chosen products. Feel free to deselect any variant you prefer not to include in your bundle. It's all about crafting the perfect offer for your shoppers!</p> */}

                <button onClick={handleNextClick} className={`px-4 py-2 ml-auto rounded font-urbanist-regular font-semibold text-base text-center text-buttonText ${Object.keys(selectedLocalProduct).length > 0 ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`} type='button'>
                    Next
                </button>
            </div>
        </div>
    );
}

export default SelectProduct;
